var _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "26px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "17 11 12 6 7 11"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "17 17 12 12 7 17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpSvgrepoCom);
export default __webpack_public_path__ + "static/media/up-svgrepo-com.672b82f521fe0d84bb7b1f14fde8b904.svg";
export { ForwardRef as ReactComponent };